/**
 * The route the dashboard micro-frontend is mounted on. It renders nothing itself: its
 * container is static markup in `index.ejs`, because single-spa mounts the dashboard
 * before React has flushed its first render.
 */
export default function Dashboard() {
  return null;
}
